import React, { useState } from "react"
import { EWsrvTransform, IMediaItem } from "../../lib";
import { ILinkFunc } from "../../lib/util";
import { Button } from "../Button";
import { WsrvImage } from "../Media";
import Heading from "./Heading";
import Select from "react-select";

export interface IFeaturedContentOption {
    label: string
    content: string;
    link?: { label: string; url: string };
    image: IMediaItem;
}

export interface IFeaturedWithDropdownContentProps {
    className?: string;
    linkFunc?: ILinkFunc;
    title?: string;
    titleHeadingLevel?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p";
    subtitle?: string;
    contentOptions: IFeaturedContentOption[];
}

export const FeaturedWithDropdownContent: React.FC<IFeaturedWithDropdownContentProps> = ({
    className = "",
    linkFunc,
    title,
    titleHeadingLevel = "h1",
    subtitle,
    contentOptions,
}) => {
    const selectStyles: any = {
        control: (base: object, state: any) => ({
            ...base,
            background: "transparent",
            borderColor: "transparent",
            borderBottomColor: "var(--color-body-text)",
            borderRadius: 0,
            width: "80%",
            maxWidth: "19rem",
            "&:hover": {
                borderColor: "transparent",
                borderBottomColor: "var(--color-body-text)",
            }
        }),
        singleValue: (base: object) => ({
            ...base,
            color: "var(--color-body-text)",
            fontSize: "1.5rem",
            lineHeight: "1.15em",
            fontStyle: "italic"
        }),
        menu: (base: object) => ({
            ...base,
            color: "var(--color-body-text)",
            fontSize: "1.5rem",
            lineHeight: "1.15em",
            fontStyle: "italic"
        }),
        dropdownIndicator: (base: object) => ({
            ...base,
            paddingRight: "0px",
            color: "var(--color-body-text)",
        }),
        indicatorSeparator: (base: object) => ({
            ...base,
            display: "none",
        }),
        placeholder: (base: object) => ({
            ...base,
            color: "var(--color-body-text)",
            whiteSpace: "nowrap",
            lineHeight: "2.5rem",
            textTransform: "uppercase",
        }),
        valueContainer: (base: object) => ({
            ...base,
            padding: 0,
        }),
    }

    const linkf = linkFunc || ((props) => <a {...props} />);

    const [currentImage, setCurrentImage] = useState(contentOptions[0].image)
    const [currentContent, setCurrentContent] = useState(contentOptions[0].content)
    const [currentValue, setCurrentValue] = useState(contentOptions[0])

    const optionChangeHandler = (option?: any) => {
        let optionIndex = option.value
        let optionImage = contentOptions[optionIndex]?.image
        let optionContent = contentOptions[optionIndex]?.content
        setCurrentImage(optionImage);
        setCurrentContent(optionContent);
        setCurrentValue(option);
    }

    const dropdownOptions: any[] = contentOptions.map((option, index) => {
        return {
            label: option.label,
            value: index
        }
    })

    return (
        <section className={`featured-dropdown-content flex flex-row flex-wrap w-full ${className}`}>
            <div className="w-full pb-10">
                {title && (<Heading className="text-left py-0" headingLevel={titleHeadingLevel}>{title}</Heading>)}
                {subtitle && (
                    <div className="flex flex-row flex-nowrap items-center italic pt-2">
                        <div className="w-20 border-t border-solid"></div>
                        <span className="pl-3 text-xl">{subtitle}</span>
                    </div>
                )}
            </div>
            <div className="lg:w-2/3 lg:pr-8">
                <WsrvImage
                    urlParams={{
                        originURL: currentImage.url,
                        preset: EWsrvTransform.cover3x2,
                    }}
                    imgProps={{
                        className: "max-w-full",
                    }} />
            </div>
            <div className="lg:w-1/3 flex-row flex-wrap pt-3 lg:pt-0">
                <Select
                    value={currentValue}
                    options={dropdownOptions}
                    isMulti={false}
                    styles={selectStyles}
                    onChange={(option) => optionChangeHandler(option)}
                />
                <div className="w-full pt-7" dangerouslySetInnerHTML={{ __html: currentContent }}>
                </div>
            </div>
        </section>
    )
}

export default FeaturedWithDropdownContent